module.exports = __webpack_public_path__ + "img/live-chat.95de7c02.png";